export const gaUserGuideContent = {
  es: `
## Guía: Cómo dar de alta un usuario de servicio en Analytics

### Pasos para la configuración:

- Accede a <a href="https://analytics.google.com/analytics/web/" target="_blank" rel="noopener noreferrer">https://analytics.google.com/analytics/web/</a> e inicia sesión con la cuenta asociada a la propiedad que quieres permitir acceso.
- Una vez dentro, selecciona la cuenta y la propiedad correspondiente desde el desplegable arriba a la izquierda.
- Accede al panel de **Administrador** haciendo clic en el icono de engranaje ubicado en la esquina inferior izquierda.
- En el menú de administración, entra en la sección **"Gestión de accesos a la propiedad"** (si no lo localizas, puedes utilizar la barra de búsqueda superior).
- Haz clic en el botón azul **"+"** ubicado en la esquina superior derecha para añadir un nuevo usuario.
- En la ventana emergente, introduce la siguiente dirección de correo electrónico de la cuenta de servicio:
  <a href="mailto:datalab-ga4-6423@datalab-pro.iam.gserviceaccount.com">datalab-ga4-6423@datalab-pro.iam.gserviceaccount.com</a>
  *(Nota: Esta no es una cuenta definitiva. En caso de actualizarse en el futuro, recibirás un aviso para añadir el nuevo correo y retirar el antiguo siguiendo esta misma guía).*
- Selecciona el rol de **"Lector"**. No se requiere gestionar ni editar datos, ya que solo se recogen datos genéricos y no se accede a propiedades o datos personalizados.
- Haz clic en el botón **"Añadir"** para finalizar la configuración.
`,

  en: `
## Guide: How to register a service user in Analytics

### Configuration Steps:

- Access <a href="https://analytics.google.com/analytics/web/" target="_blank" rel="noopener noreferrer">https://analytics.google.com/analytics/web/</a> and log in with the account associated with the property you want to grant access to.
- Once inside, select the corresponding account and property from the dropdown at the top left.
- Go to the **Admin** panel by clicking the gear icon located at the bottom left corner.
- From the admin menu, navigate to the **"Property Access Management"** section (you can use the search bar if you can't find it).
- Click the blue **"+"** button at the top right to add a new user.
- In the new window, enter the following service account email address:
  <a href="mailto:datalab-ga4-6423@datalab-pro.iam.gserviceaccount.com">datalab-ga4-6423@datalab-pro.iam.gserviceaccount.com</a>
  *(Note: This is not a permanent account. If updated in the future, you will receive a notification to add the new email and remove the old one following this guide).*
- Select the **"Viewer"** role. No edit or management permissions are required, as only generic data is collected with no access to custom properties.
- Click the **"Add"** button to complete the setup.
`
}
